import Vue from 'vue'

export default {
    UPDATE_RESOURCES (state, value) {
        Vue.set(state, 'resources', value);
    },
    SET_RESOURCES (state, value) {
        this.commit('UPDATE_RESOURCES', value);
    },
    SET_SELECTED_RESOURCE (state,  value ) {
      Vue.set(state, 'selectedResource', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/resources/mutations.js